module.exports = __webpack_public_path__ + "img/g.sabev.41fc13b7.jpg";